import 'components/ui/Pager/Pager.scss';
import { ReactComponent as IconChevronLeft } from "assets/images/icons/chevron-left.svg";
import { ReactComponent as IconChevronRight } from "assets/images/icons/chevron-right.svg";
import PropTypes from "prop-types";

function Pager({ currentPage, totalPages, onChange }) {
  const maxVisibleItems = 4; // This is the number of items left and right of the current page, value must be divisible by two

  if (totalPages === 1) {
    return null;
  }

  // determine the first and last visible pager items
  let startPage = Math.max(currentPage - maxVisibleItems, 1);
  let endPage = Math.min(currentPage + maxVisibleItems, totalPages);
  if (currentPage < maxVisibleItems) {
    endPage += maxVisibleItems - currentPage;
  }
  if (endPage === totalPages) {
    startPage -= maxVisibleItems - (totalPages - currentPage);
  }

  let items = [];
  if (startPage > 1) {
    items.push(<li key={ `more-left` } className={ `pager__item--more` }>...</li>);
  }
  for (let i = Math.max(1, startPage); i <= Math.min(endPage, totalPages); i++) {
    items.push(
      <li
        key={ i }
        onClick={ () => onChange(i) }
        className={ `pager__item ${ currentPage === i ? 'pager__item--active' : '' }` }>
        { i }
      </li>
    );
  }
  if (endPage < totalPages) {
    items.push(<li key={ `more-right` } className={ `pager__item--more` }>...</li>);
  }

  return (
    <div className={ 'pager' }>
      {
        currentPage > 1 &&
        <div className={ 'pager__item' } onClick={ () => onChange(currentPage - 1) }>
          <IconChevronLeft/>
        </div>
      }

      <ul>
        { items }
      </ul>

      {
        currentPage < totalPages &&
        <div className={ 'pager__item' } onClick={ () => onChange(currentPage + 1) }>
          <IconChevronRight/>
        </div>
      }
    </div>
  );
}

Pager.propTypes = {
  currentPage: PropTypes.number.isRequired,
  totalPages: PropTypes.number.isRequired
}

export default Pager;
